exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-revoke[data-v-1304379f] {\n    -webkit-flex-grow: 1;\n            flex-grow: 1;\n    -webkit-justify-content: flex-end;\n            justify-content: flex-end;\n    display: -webkit-flex;\n    display: flex;\n}\n", ""]);

// exports
